export default {"src":"/_next/static/media/solar_filter-outline.e4063e63.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};